export default __webpack_public_path__ + "static/artem-goncharov-4474f191d79e38e082acf50dbd67fbaa.png";